import {Component, Input, OnInit} from '@angular/core';
import {BaseResultComponent} from "../../base-result/base-result.component";
import {NbWindowService} from "@nebular/theme";
import {Safeguard} from "../../../../class/result/safeguard/safeguard";

@Component({
  selector: 'app-safe-guard-card',
  templateUrl: './safe-guard-card.component.html',
  styleUrls: ['./safe-guard-card.component.css']
})
export class SafeGuardCardComponent extends BaseResultComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  showCoverFlags: boolean;

  @Input()
  safeguard: Safeguard;

  constructor(windowService: NbWindowService) {
    super(windowService);
  }

  ngOnInit() {
  }

}
